import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { TextField } from 'shared/ui/TextField'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import type { IntegrationWebhookStore } from 'pages/settings/pages/integrations/store/IntegrationWebhookStore'
import { CreateContactWithSwitch } from 'pages/settings/pages/integrations/pages/CreateContactWithSwitch/CreateContactWithSwitch'
import { WebhookCopyButton } from './WebhookCopyButton'
import styles from './styles.module.scss'

type IIntegrationSettingsWebhookProps = {
  store: IntegrationWebhookStore
  withLeadOwner?: boolean
}

export const IntegrationSettingsWebhook: FC<IIntegrationSettingsWebhookProps> = observer(
  ({ store, withLeadOwner = false }) => {
    const {
      webhookUrl,
      sendFromLeadOwner,
      handleSendFromLeadOwnerToggle,
      phoneFieldsItems,
      handleSelectedPhoneFieldChange,
      selectedPhoneField,
      integrationName,
    } = store

    return (
      <div className={styles.root}>
        <TitledRow
          title={`Use this Webhook URL on ${integrationName} to send Contacts into your Salesmsg account. This will:`}
          label={
            <ul>
              <li>Create a Contact on your account if one does not exist.</li>
              <li>Link the Contact to it&apos;s counterpart on {integrationName}.</li>
            </ul>
          }
        />
        <div />
        {withLeadOwner && (
          <>
            <div className={styles.row}>
              <CreateContactWithSwitch
                integrationName={integrationName}
                sendFromLeadOwner={sendFromLeadOwner}
                handleSendFromLeadOwnerToggle={handleSendFromLeadOwnerToggle}
              />
            </div>
            <div className={styles.divider} />
          </>
        )}
        <TitledRow
          title={'Phone field'}
          tooltip={
            'By default we have selected the standard phone number field. If you want this Webhook URL to use a different field, select a new one from the dropdown before copying the URL.'
          }
          align={'normal'}
        >
          <SelectField
            size={'medium'}
            withSearch={false}
            items={phoneFieldsItems}
            value={selectedPhoneField}
            setValue={handleSelectedPhoneFieldChange}
            selectProps={{
              placeholder: selectedPhoneField,
            }}
          />
        </TitledRow>
        <div className={styles.divider} />
        <Typography ariaLabel={'label'} variant={'body-md-medium'}>
          Webhook URL
        </Typography>
        <div className={styles.urlForm}>
          <TextField
            className={styles.input}
            size={'medium'}
            variant={'stroke'}
            value={webhookUrl}
            InputProps={{
              placeholder: 'Webhook URL',
            }}
          />
          <WebhookCopyButton url={webhookUrl} />
        </div>
      </div>
    )
  }
)
